import $ from 'jquery';

function mobileMenu() {
	const $menu      				= $('.c-mobile-menu'),
				$accordionMenu   	= $('.c-mobile-menu_menu'),
	      $dropdowns 				= $menu.find('.menu-item-has-children');
				
	$dropdowns.each(function() {
		const $label  = $(this).find('.menu-item-parent-label'),
		      $toggle = $(this).find('.is-dropdown');
					 
		$(this).prepend('<span class="c-mobile-menu_dropdown-wrapper" />');
		
		const $wrapper = $(this).find('.c-mobile-menu_dropdown-wrapper');
		
		$wrapper.append($label, $toggle);
	});	

	// Update aria selected state
	$accordionMenu.on('down.zf.accordionMenu', function(event, element) {
		$(element.context).attr('aria-selected', true);
	}).on('up.zf.accordionMenu', function(event, element) {
		$(element.context).attr('aria-selected', false);
	});
}

export { mobileMenu }